export let CrearArticuloRouteComponent = {
    selector: 'crearArticuloRoute',
    template: require('./crear-articulo.html'),
    bindings: {
        categorias: '<'
    },
    controller: class {

        categoriaSeleccionada;
        subcategoriaSeleccionada;

        /*@ngInject*/
        constructor(ArticuloService, $location, Upload, IMAGE_UPLOAD_URL, ToasterService) {
            Object.assign(this, {ArticuloService, $location, Upload, IMAGE_UPLOAD_URL, ToasterService});
            this.articulo = {unidad: 'C/U'};
        }

        crearArticulo(form) {
            if (form.$valid) {
                if (this.categoriaSeleccionada && this.subcategoriaSeleccionada) {

                    this.articulo.categoria = this.categoriaSeleccionada.categoria.toUpperCase();
                    this.articulo.subcategoria = this.subcategoriaSeleccionada.subcategoria.toUpperCase();

                    if (this.file) {
                        this.Upload.upload({
                            url: this.IMAGE_UPLOAD_URL,
                            data: {
                                file: this.file
                            }
                        })
                            .then((img) => {
                                this.articulo.imagenUrl = img.data.secure_url;
                                this.ArticuloService.crearArticulo(this.articulo)
                                    .then((art) => {
                                        this.ToasterService.popUp('success', 'Articulo', 'Se ha creado con éxito.');
                                        this.$location.path(`/articulo/ver/${art.data._id}`);
                                    }, (error) => {
                                        this.ToasterService.popUp('danger', 'Error en articulo', error.data);
                                    });
                            })
                    } else {
                        this.ArticuloService.crearArticulo(this.articulo)
                            .then((art) => {
                                this.ToasterService.popUp('success', 'Articulo', 'Se ha creado con éxito.');
                                this.$location.path(`/articulo/ver/${art.data._id}`);
                            }, (error) => {
                                this.ToasterService.popUp('danger', 'Error en articulo', error.data);
                            });
                    }
                } else {
                    this.ToasterService.popUp('info', 'Categoria', 'Seleccione una categoria y subcategoria.');
                }
            }
        }

        uploadFiles(file, error) {
            this.file = file;
        }


    }
};



// WEBPACK FOOTER //
// ./client/app/articulo-route/crear/crear-articulo.component.js